import app from 'flarum/forum/app';
import updateHomePage from './updateHomePage';


app.initializers.add('dvdfab/homepage', () => {
  updateHomePage();
});
